<template>
  <div>
    <b-modal
      @ok="onCreateCashflow"
      @cancel="hideModal"
      no-close-on-backdrop
      ref="CashflowModal"
      size="lg"
      title="Add Cash Flow"
      centered
    >
      <b-row>
        <b-col>
          <b-row v-if="loading" class="d-flex justify-content-center">
            <b-spinner
              style="width: 3rem; height: 3rem"
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </b-row>
        </b-col>
      </b-row>
      <form-wrapper :validator="$v.cashflow">
        <b-row>
          <b-col cols="6">
            <label>Cash Type</label>

            <DropDown v-model="cashflow.type" :options="cashTypes" />
          </b-col>
          <b-col cols="6">
            <label for="datepicker">Date</label>
            <b-form-datepicker
              id="datepicker"
              v-model="cashflow.date"
              class="mb-2"
            ></b-form-datepicker>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <label>Ledger Type</label>

            <DropDown
              v-model="cashflow.ledger_type_id"
              :options="ledgerTypes"
            />
          </b-col>
          <b-col cols="6">
            <label>Amount</label>
            <BaseInput v-model="cashflow.amount" name="amount" type="number" />
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col cols="12">
            <label>Note</label>

            <BaseInput
              v-model="cashflow.explanation"
              name="remarks"
              id="textarea"
              type="textarea"
              rows="3"
              max-rows="6"
            />
          </b-col>
        </b-row>
      </form-wrapper>
      <div slot="modal-footer">
        <b-button
          variant="primary"
          type="submit"
          size="sm"
          @click="onCreateCashflow"
        >
          OK
        </b-button>
        <b-button
          variant="secondary"
          class="ml-2"
          type="submit"
          size="sm"
          @click="hideModal"
        >
          Cancel
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
// Components
import BaseInput from "@/components/base/Input";
import DropDown from "@/components/base/DropDown";
import DatePicker from "@/components/base/BaseDatePicker";
//state management from vuex
import { mapState, mapGetters } from "vuex";
//moment format
import moment from "moment";
// Vuelidate validations
import { required } from "vuelidate/lib/validators";

export default {
  name: "Cashflow Create",
  data: () => ({
    loading: false,
    cashTypes: [
      { id: "Deposit", name: "Cash In" },
      { id: "Withdrawal", name: "Cash Out" },
    ],
    cashflow: {
      amount: "",
      date: "",
      explanation: "",
      ledger_type_id: 1,
      shop_id: null,
      type: "Deposit",
    },
  }),

  components: {
    BaseInput,
    DropDown,
    DatePicker,
  },

  validations: {
    cashflow: {
      amount: { required },
      date: {},
      explanation: { required },
      ledger_type_id: {},
      shop_id: {},
      type: {},
    },
  },

  created: function() {
    this.fetchLedgerTypes();
    this.cashflow.date = moment(new Date(), "DD-MM-YYYY").format("YYYY-MM-DD");
  },

  computed: {
    ...mapState("supplier", ["ledger_types"]),
    ...mapGetters("shops", ["GetShopId"]),

    ledgerTypes: function() {
      if (this.ledger_types.length != 0) {
        return this.ledger_types.map((item) => {
          return { name: item.name, id: item.id };
        });
      }
      return [];
    },
  },

  methods: {
    isValid() {
      this.$v.$touch();
      let status = false;
      status = !this.$v.$invalid;
      if (status) {
        return true;
      }
      return false;
    },

    fetchLedgerTypes() {
      this.$store.dispatch("supplier/fetchLedgerTypes", this.cashflow);
    },

    onCreateCashflow() {
      this.cashflow.shop_id = this.GetShopId;
      if (this.isValid()) {
        this.loading = true;

        this.$store
          .dispatch("shops/onCreateCashflow", this.cashflow)
          .then((res) => {
            this.loading = false;
            this.showToast("Cash Flow successfully created", "Success");
            this.cashflow = {
              amount: "",
              date: "",
              explanation: "",
              ledger_type_id: "",
              type: "Deposit",
            };
            this.$v.$reset();
            this.hideModal();
            this.$store.dispatch("shops/fetchCashflowData");
          })
          .catch((err) => {
            this.loading = false;
            this.showToast("Cash Flow failed to create", "danger");
          });
      }
    },
    showModal() {
      this.$refs["CashflowModal"].show();
      this.cashflow = {
        amount: "",
        date: "",
        explanation: "",
        ledger_type_id: 1,
        shop_id: null,
        type: "Deposit",
      };
    },
    hideModal() {
      this.$refs["CashflowModal"].hide();
    },
    showToast(message, variant = null) {
      this.$bvToast.toast(message, {
        title: "Message",
        variant,
        solid: true,
      });
    },
  },
};
</script>
<style></style>
